import { XingUser } from '../XingUser';

export class Consultant extends XingUser { }
